// extracted by extract-css-chunks-webpack-plugin
module.exports = {"product-card-wrapper-recommendations":"PNKHi","product-card-block":"CKWQC","text":"liyyl","triangle":"QLEet","two":"kLIaY","active":"twUfF"};